// dat文件解析

export const parseDatFile = (content) => {
    const lines = content.split('\n').filter(line => line.trim() !== '');
    const sections = [];
    let currentSection = null;

    for (const line of lines) {
        if (line.startsWith('[') && line.endsWith(']')) {
            // 提取section名称
            const sectionName = line.slice(1, -1);
            currentSection = {
                name: sectionName,
                data: {},
                originalIndex: sections.length
            };
            sections.push(currentSection);
        } else if (currentSection && line.includes('=')) {
            const [key, value] = line.split('=', 2);
            currentSection.data[key.trim()] = value.trim();
        }
    }
    return sections;
};